// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__VKt+n","footer":"NavbarSimple_footer__mkYhl","link":"NavbarSimple_link__+umFw","linkIcon":"NavbarSimple_linkIcon__hmuin"};